<template>
	<div class="DocsEditor" v-loading.fullscreen.lock="fullscreenLoading"
				element-loading-text="Загрузка данных..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)">
		<template v-if="masDevs.length > 0">
			<card class="col-sm-12" v-for="(objDev,index) in masDevs" :key="index">
				<div class="DEV-docs mb-4">
					<h4 class="DEV-name px-1 mb-0">{{$GVO.GetCat('CAT_DEV',objDev.dc_dev_name_tr).name}}</h4>
					<div class="DEV-file" v-for="file in objDev.dev_files" :key="file.filename">
						<div class="DEV-file-row ">
							<a :href="file.filepath" target="_blank">{{file.filename}}</a>							
							<el-tooltip content="Удалить файл" placement="top">
								<el-button class="no-border my-0">
									<button class="ml-3 btn btn-icon btn-simple btn-danger my-2" @click="DelDevFile(file.id,objDev.dc_dev_name_tr)">
										<i class="tim-icons icon-trash-simple"></i>
									</button>										
								</el-button>
							</el-tooltip>
						</div>					
					</div>
					<div class="doc-add-row mt-3">		
						<template v-if="fileDevUpload_model[objDev.dc_dev_name_tr]==''">
							<div class="upload-file">
								<ReFileUpload 
									v-model="fileDevUpload_model[objDev.dc_dev_name_tr]"
									type="file"
									:formId="'devupload_'+objDev.dc_dev_name_tr"
									:multiple="false"
									acceptMime="*/*"
									:bShowTrash="false"
									v-on:change="OnDevUploadFile"
								/>
							</div>
						</template>
					</div>

				</div>

				<collapse v-if="typeof objDev.full_dev.masComlex != 'undefined'">
					<collapse-item :title="complex.gk_name" class="GK-docs" v-for="complex in objDev.full_dev.masComlex" :key="complex.id">
						<el-table :data="complex.gk_files">
							<el-table-column
								min-width="130"
								sortable
								label="Файл"
							>							
								<template v-slot="scope">
									<a :href="scope.row.filepath" target="_blank">{{ scope.row.filename }}</a>
								</template>
							</el-table-column>
							<el-table-column
								sortable
								min-width="130"								
								label="Каталог"
								property="catalog"
							>
								<template v-slot="scope">
									<p>{{ folderName(scope.row.filepath) }}</p>
								</template>
							</el-table-column>
							<el-table-column
								align="right"
								min-width="100"								
								label="Удалить"					
							>
								<template v-slot="scope">										
									<el-tooltip content="Удалить файл" placement="top">
										<el-button class="no-border my-0">
											<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="DelGkFile(scope.row.id,complex.gk_name_tr)">
												<i class="tim-icons icon-trash-simple"></i>
											</button>											
										</el-button>
									</el-tooltip>
								</template>
							</el-table-column>
						</el-table>

						<div class="doc-add-row">
							<el-select
								v-model="fileGkFolder_model[complex.gk_name_tr]"
								class="col-md px-0 pr-3 select-primary"	
								placeholder="Выбрать каталог"
								size="large"
							>
								<el-option
									v-for="(el_opt, el_index) in masFoldersOpts"
									class="select-primary"
									:value="el_opt.value"
									:label="el_opt.label"
									:key="el_index"
								>
								</el-option>
							</el-select>
							<template v-if="fileGkUpload_model[complex.gk_name_tr]==''">
								<div class="upload-file pr-1">
									<ReFileUpload 
										v-model="fileGkUpload_model[complex.gk_name_tr]"
										type="file"
										:formId="'gkupload_'+complex.gk_name_tr"
										:multiple="false"
										acceptMime="*/*"
										:bShowTrash="false"
										v-on:change="OnGkUploadFile"
									/>
								</div>
							</template>
						</div>
					</collapse-item>
				</collapse>
					
			</card>
		</template>
		<template v-else>
			<h3>У Вас нет курируемых застройщиков</h3>
		</template>
	</div>
</template>

<script>
	import { Collapse, CollapseItem } from 'src/components';
	import { Table, TableColumn } from 'element-ui';
	import { Select, Option, Tooltip, Button } from 'element-ui';
	import ReFileUpload from "src/our_components/ReFileUpload.vue";


	export default {
		name: 'docs_editor-page',
		components: {
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			[Option.name]: Option,
			[Select.name]: Select,
			Collapse,
			CollapseItem,
			ReFileUpload,
			[Tooltip.name]: Tooltip,	
			[Button.name]: Button	
			
		},
		props: {

		}, 
		
		data() {
			return {
				bIsPostForm: false,	
				strNote: '',
				field_name: '',
				field_descr: '',
				field_act: '',
				fileUpload_model: '',
				fileDevUpload_model: {},
				fileGkUpload_model: {},
				gkname: 'Название ЖК',
				tableData: [
					{
					id: 1,
					catalog: 'Планировки',
					filename: 'text.docs',							
					},				
				],
				masDevs:[],
				masFoldersOpts:[],
				fileGkFolder_model: {},
				fullscreenLoading: false,
    		}
		},
		computed:{
			
		},
		methods: {
			folderName: function(strFullPath){
				let masPath = strFullPath.split('/');
				return masPath[masPath.length-2];
			},
			showPostForm() {
				this.bIsPostForm = !this.bIsPostForm;
				/*this.$nextTick(() => {
					this.$refs.saveInput.focus();
				});*/
			},
			cancelForm() {
				this.bIsPostForm = !this.bIsPostForm;
				this.fileUpload_model = '';
				this.strNote = '';
			},
			DoDel(){			
				this.fileUpload_model = '';
			},
			OnUploadFile(objData){
				//console.log('OnUploadFile', objData);
				this.bUploading=true;
				let objSendApi = {obj:'FileUpload',flt:{type:'notes_file'}};			
				this.$GVO.UploadFile(objData.formId,'UniUpload',objSendApi)
				.then(objApi => {  
					//console.log(objApi);
					if(objApi.success){
						this.fileUpload_model = objApi.data;
					}else{
						alert(objApi.msg);
					}
					this.bUploading=false;
				})
				.catch(errorObjApi => {console.error(errorObjApi); this.bUploading=false;});
			},
			GetData(){
				this.$GVO.ApiCall('GetMyDevExtraData',{obj:'DEV' ,flt:{with_complex:true,with_files:true}})
				.then((objApi) => {
					if(objApi.success === true){
						//console.log(objApi.data);	
						this.openFullScreen1();			
						this.$GVO.LoadCatPromise('CAT_DEV',true).then((bCatLoaded) => {
							
							this.fileDevUpload_model={};
							this.fileGkUpload_model={};
							this.fileGkFolder_model={};
							this.masDevs = objApi.data;
							for (let i = 0; i <  objApi.data.length; i++) {
								this.fileDevUpload_model[objApi.data[i].dc_dev_name_tr]='';
								if(typeof objApi.data[i].full_dev.masComlex != 'undefined' && objApi.data[i].full_dev.masComlex.length>0){
									for (let x = 0; x <  objApi.data[i].full_dev.masComlex.length; x++) {
										this.fileGkUpload_model[objApi.data[i].full_dev.masComlex[x].gk_name_tr]='';
										this.fileGkFolder_model[objApi.data[i].full_dev.masComlex[x].gk_name_tr]='';
									}
								}
							}
							this.fileDevUpload_model = this.$GVO.SafeParseJson(JSON.stringify(this.fileDevUpload_model));
							this.fileGkUpload_model = this.$GVO.SafeParseJson(JSON.stringify(this.fileGkUpload_model));
							this.fileGkFolder_model = this.$GVO.SafeParseJson(JSON.stringify(this.fileGkFolder_model));
						}).catch(errorObjApi => {console.error(errorObjApi);});
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});
			},
			OnDevUploadFile(objData){
				//console.log('OnDevUploadFile', objData);
				//return true;
				const dev_name_tr = this.$GVO.str_replace('devupload_','',objData.formId);
				this.bUploading=true;
				let objSendApi = {obj:'FileUpload',flt:{'type':'dev_files','dev_name_tr':dev_name_tr}};
				this.$GVO.UploadFile(objData.formId,'UploadDevGkFiles',objSendApi)
				.then(objApi => {  
					// console.log(objApi);
					if(objApi.success){
						this.GetData();
					}else{
						console.error(objApi.msg);
					}
					this.bUploading=false;
				})
				.catch(errorObjApi => {console.error(errorObjApi); this.bUploading=false;});
			},
			DelDevFile(file_id,dev_name_tr){
				this.$GVO.ApiCall('DEL_DEV_FILE',{obj:'DEV' ,flt:{"file_id":file_id,"dev_name_tr":dev_name_tr}})
				.then(objApi => {  
					// console.log(objApi);
					if(objApi.success){
						this.GetData();
					}else{
						console.error(objApi.msg);
					}
					this.bUploading=false;
				})
				.catch(errorObjApi => {console.error(errorObjApi); this.bUploading=false;});
			},
			OnGkUploadFile(objData){
				//console.log('OnDevUploadFile', objData);
				const gk_name_tr = this.$GVO.str_replace('gkupload_','',objData.formId);
				const folderName = this.$GVO.GetCat('CAT_GK_FOLDERS',this.fileGkFolder_model[gk_name_tr]).name;
				if(folderName == '' || typeof folderName == 'undefined'){
					this.$GVO.showAlert('Загрузка файла','Не выбран каталог');
					return true;
				}
				this.bUploading=true;
				let objSendApi = {obj:'FileUpload',flt:{'type':'gk_files','gk_name_tr':gk_name_tr,'subfolder':folderName}};
				this.$GVO.UploadFile(objData.formId,'UploadDevGkFiles',objSendApi)
				.then(objApi => {  
					// console.log(objApi);
					if(objApi.success){
						this.GetData();
					}else{
						console.error(objApi.msg);
					}
					this.bUploading=false;
				})
				.catch(errorObjApi => {console.error(errorObjApi); this.bUploading=false;});
			},
			DelGkFile(file_id,gk_name_tr){
				this.$GVO.ApiCall('DEL_GK_FILE',{obj:'NovoObj' ,flt:{"file_id":file_id,"gk_name_tr":gk_name_tr}})
				.then(objApi => {  
					// console.log(objApi);
					if(objApi.success){
						this.GetData();
					}else{
						console.error(objApi.msg);
					}
					this.bUploading=false;
				})
				.catch(errorObjApi => {console.error(errorObjApi); this.bUploading=false;});
			},
			openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 2000);
		},
		},
		mounted() {
			this.GetData();
			this.$GVO.LoadCatPromise('CAT_GK_FOLDERS',true).then((bCatLoaded) => {
				this.masFoldersOpts = this.$GVO.getCatToSelect('CAT_GK_FOLDERS');
			}).catch(errorObjApi => {console.error(errorObjApi);});
		}
	};
</script>

<style>

.doc-add-row {display: flex; align-items: center; padding-top: 10px;}
.delete-row{
	display: flex;
	align-items: baseline;
	justify-content: flex-end;		
}
.DEV-file-row {display: flex;align-items: center; justify-content: space-between; border-bottom: 1px solid #01B0E0;}
.DocsEditor .card-collapse .card:not(.card-cinc) .card-header a {    
    color: #01B0E0;
}
.DEV-file, .DEV-docs {display: flex; flex-direction: column; padding: 0px;}
.DocsEditor .fileinput {margin-top: 0px;}

/*============================ SEND NOTES ========================================*/
.postAddForm-hide {
	display: none;
}
.postAddForm-show {
	display: block;
	margin-top: 15px;
}
.postForm {
	border: 1px solid transparent;
	border: 1px solid #01B0E0;
	border-radius: 0.2857rem;
	position: sticky;
	bottom: 0;		
}
.postForClick {cursor: pointer;}
.postForm >>> .card-body {padding: 0px 5px 15px 10px!important;}
.cancel-note-btn {position: absolute;  top: 0; right: 0;}
.clientPage .card-collapse .postForm {
	background: #27293d;
}
.white-content .card:not(.card-white) .postForm {
	background: #fff;
}
.postForm:hover, .focus-shadow  {
	box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.postForm h5 {
	margin-bottom: 0px;
}
.form-container {display: flex; flex-direction: column; justify-content: space-between; padding: 0px 5px;}
.postForm .bottom_part, .top_part  {display: flex; flex-wrap: wrap; justify-content: space-between;}
.postForm .bottom_part button, .fileinput {margin: 10px 10px 0px 0px;}

.postAddForm >>> .nav-pills .nav-item i {line-height: 30px;}
.postAddForm >>> .nav-pills .nav-item .nav-link {padding: 7px 20px; min-width: 80px;}
.postAddForm >>> .tab-space {padding: 20px 0 10px 0px;}
.upload-file {display: flex; align-items: center;}
.upload-file h5 {margin-bottom: 0px; margin-right: 10px;}
.upload-file:hover {cursor: pointer;}

.note-btn-group {position: relative;}
.note-btn-row {position: absolute; top: 5px; right: 0;}
.DocsEditor >>> .el-table {margin-bottom: 0;}
.GK-docs .el-table table {margin-bottom: 0;}




/*===media===============================*/
@media (max-width: 768px) {	
	
}

</style>
